import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["claimedBody", "readyBody", "claimedCount", "readyCount", "empty", "loading"]
  static values = { url: String, clearUrl: String, restartUrl: String }

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), 15000)
  }

  disconnect() {
    if (this.timer) { clearInterval(this.timer); this.timer = null }
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue)
      if (!res.ok) return
      const data = await res.json()
      this.render(data)
    } catch (e) {
      console.error("Queue poll error:", e)
    }
  }

  render(data) {
    if (this.hasLoadingTarget) this.loadingTarget.style.display = "none"

    const claimed = data.claimed || []
    const ready = data.ready || []

    if (this.hasClaimedCountTarget) this.claimedCountTarget.textContent = claimed.length
    if (this.hasReadyCountTarget) this.readyCountTarget.textContent = ready.length

    if (this.hasClaimedBodyTarget) {
      if (claimed.length === 0) {
        this.claimedBodyTarget.innerHTML = '<tr><td colspan="4" class="jq-empty">No running jobs</td></tr>'
      } else {
        this.claimedBodyTarget.innerHTML = claimed.map(j => `
          <tr>
            <td class="jq-job-name">${this.escapeHtml(j.class_name)}</td>
            <td>${j.age_minutes} min</td>
            <td>${j.age_minutes > 30 ? '<span class="jq-stuck">Possibly stuck</span>' : '<span class="jq-ok">Running</span>'}</td>
            <td>
              <button class="spt-btn-danger spt-btn-sm" data-action="click->job-queue#clearJob" data-job-id="${j.id}">Remove</button>
            </td>
          </tr>
        `).join("")
      }
    }

    if (this.hasReadyBodyTarget) {
      if (ready.length === 0) {
        this.readyBodyTarget.innerHTML = '<tr><td colspan="3" class="jq-empty">Queue empty</td></tr>'
      } else {
        this.readyBodyTarget.innerHTML = ready.map(j => `
          <tr>
            <td class="jq-job-name">${this.escapeHtml(j.class_name)}</td>
            <td>${j.queue}</td>
            <td>
              <button class="spt-btn-ghost spt-btn-sm" data-action="click->job-queue#clearJob" data-job-id="${j.id}">Remove</button>
            </td>
          </tr>
        `).join("")
      }
    }
  }

  async clearJob(event) {
    const jobId = event.currentTarget.dataset.jobId
    if (!confirm("Remove this job from the queue?")) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const url = this.clearUrlValue.replace("__JOB_ID__", jobId)

    try {
      const res = await fetch(url, {
        method: "DELETE",
        headers: { "X-CSRF-Token": token }
      })
      if (res.ok) {
        this.poll()
      } else {
        alert("Failed to remove job")
      }
    } catch (e) {
      alert("Error: " + e.message)
    }
  }

  async releaseStuck() {
    if (!confirm("Release all stuck jobs and re-queue them? This is safe to do.")) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const res = await fetch(this.restartUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": token }
      })
      if (res.ok) {
        this.poll()
      } else {
        alert("Failed to release jobs")
      }
    } catch (e) {
      alert("Error: " + e.message)
    }
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str || ""
    return div.innerHTML
  }
}
